<form class="filter" #formElement [formGroup]="form">


  <mat-form-field class="medium-width margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="dateFrom"
      [matDatepicker]="pickerFrom"
      placeholder="Desde"
      required
    />
    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
    <mat-datepicker #pickerFrom></mat-datepicker>
    <mat-error *ngIf="f.dateFrom.errors && f.dateFrom.errors.required">
      Ingrese la fecha desde
    </mat-error>
  </mat-form-field>

  <mat-form-field class="medium-width margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="dateTo"
      [matDatepicker]="pickerTo"
      placeholder="Hasta"
      required
    />
    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
    <mat-datepicker #pickerTo></mat-datepicker>
    <mat-error *ngIf="f.dateTo.errors && f.dateTo.errors.required">
      Ingrese la fecha hasta
    </mat-error>
  </mat-form-field>


<mat-form-field class="full-width">
  <input type="text" #client matInput placeholder="Cliente" formControlName="client" [matAutocomplete]="autClient">
  <mat-autocomplete #autClient="matAutocomplete" [displayWith]="filterCompleteClients.displayFn">
      <mat-option *ngFor="let client of filteredClientsOptions | async" [value]="client">
          {{ client.Name }}
      </mat-option>
  </mat-autocomplete>
</mat-form-field>


  <div class="full-width">
    <patient-autocomplete formControlName="patient"></patient-autocomplete>
</div>


<mat-form-field class="full-width">
  <input
    matInput
    formControlName="label"
    placeholder="Etiqueta"
  />

</mat-form-field>


  <mat-checkbox class="margin-right-small" formControlName="viewNoControlled">Ver sín controlar</mat-checkbox>
  <mat-checkbox class="margin-right-small" formControlName="viewRejected">Ver rechazadas</mat-checkbox>
  <mat-checkbox class="margin-right-small" formControlName="viewAcepted">Ver aceptadas</mat-checkbox>

</form>
